module.exports = __webpack_public_path__ + "static/media/run.90c83330.fbx";